export default {
    name : 'collapse',
    init(){
        let sources = document.querySelectorAll('[data-menuhead]');
        let targets = document.querySelectorAll('[data-target]');

        if(!sources && window.innerWidth > 500){
            return;
        }

        for(const source of sources){
            source.addEventListener('click',()=>{
                for(const target of targets ){
                    const sourceClass=source.classList[0]+'--active';
                    if(target.getAttribute('data-target') == source.getAttribute('data-menuhead')){
                        if(source.classList.contains(sourceClass)){
                            source.classList.remove(sourceClass);
                        }
                        else{
                            source.classList.add(sourceClass);
                        }
                    }
                }
                
            })
        }
    }
}